module.exports = __webpack_public_path__ + "static/img/5.2b50367.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/eng/5.png
// module id = +LO0
// module chunks = 0